import { html, LitElement } from 'lit';

export default class MoreinfoWebComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    name: { type: String },
    data: { type: Object }
  };

  constructor() {
    super();
    this.name = 'Moreinfo Web Component';
    this.data = {};
  }

  async connectedCallback() {
    super.connectedCallback();
  }

  updated() {
    // Eliminar cualquier script anterior para evitar duplicados
    const oldScript = document.querySelector('script[src="https://www.tiktok.com/embed.js"]');
    if (oldScript) {
      oldScript.remove();
    }

    // Crear y añadir el nuevo script
    const script = document.createElement('script');
    script.src = 'https://www.tiktok.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
  }

  render() {
    return html`
      <section class="moreinfo-component">
        <img
          src="/dist/682cb21375090987c270aecb/static/logo-header-1.png"
          class="moreinfo-component__img"
          alt="Drumstick Logo"
        />

        .
        <p
          class="moreinfo-component__text"
          aria-label="Summer Snackdown promotion. Buy Drumsticks for a chance to win prizes all summer."
        >
          <b>THE WWE & DRUMSTICK SUMMER SNACKDOWN SWEEPSTAKES IS ON.</b><br />
          <br />Grab a box of Drumsticks and you’re in for a chance to win prizes all summer long.
        </p>

        <!-- <h3 class="ph3" aria-label="Follow us">FOLLOW US ON TIK TOK</h3> -->

        <!-- <div class="tiktok-container" role="region" aria-label="TikTok video: Drumstick featuring John Cena">
          <blockquote class="tiktok-embed" cite="https://www.tiktok.com/@drumstick/video/7495957126536449326" data-video-id="7495957126536449326" style="max-width: 605px;min-width: 325px;" title="TikTok video by @drumstick featuring John Cena. Original sound by Drumstick."> <section title="TikTok video by @drumstick featuring John Cena. Original sound by Drumstick."> <a target="_blank" title="@drumstick" href="https://www.tiktok.com/@drumstick?refer=embed">@drumstick</a> does @John Cena <a target="_blank" title="♬ original sound - Drumstick" href="https://www.tiktok.com/music/original-sound-7495957193071381294?refer=embed">♬ original sound - Drumstick</a> </section> </blockquote>
        </div> -->

        <!-- <img src="/dist/682cb21375090987c270aecb/static/dsvgewrg2.png" class="moreinfo-component__img2" alt="Drumstick Action Figure logo"> -->

        <!-- <img src="/dist/682cb21375090987c270aecb/static/drumstick-loho-home.png" class="moreinfo-component__img3" alt="Drumstick brand Logo">  -->
      </section>
    `;
  }
}

customElements.define('moreinfo-webcomponent', MoreinfoWebComponent);
